import moment from "moment";
export function renderDate(milliseconds: number): React.ReactNode {
    return moment(milliseconds).tz("Asia/Calcutta").format("MMMM Do, YYYY h:mm A") + " IST"
}